import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="关于吃瓜，你可能想问"
              description="更新频率、内容来源、投稿方式，常见疑问都整理在这里。"
            />
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
              <h3 className="mb-2 flex items-center gap-2 font-heading text-base font-bold text-primary-800">
                <i className="ri-question-answer-line" />
                还有别的问题？
              </h3>
              <p className="mb-4 text-sm leading-relaxed text-foreground-700">
                想让某条内容补充说明、修正错误，或者提交新的爆料材料，都可以直接联系我们。
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-mail-send-line" />
                联系编辑部
              </Link>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li key={item.question}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 cursor-pointer md:px-6"
                      >
                        <span className="flex items-start gap-3">
                          <span
                            className={`mt-0.5 font-heading text-sm font-bold ${
                              isOpen ? "text-primary-600" : "text-foreground-400"
                            }`}
                          >
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <span className="text-sm font-medium text-foreground-900 md:text-base">
                            {item.question}
                          </span>
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-all ${
                            isOpen
                              ? "rotate-180 border-primary-400 bg-primary-500 text-background-50"
                              : "border-background-300 text-foreground-500"
                          }`}
                        >
                          <i className="ri-arrow-down-s-line text-lg" />
                        </span>
                      </button>
                    </h3>
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        isOpen ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                      }`}
                    >
                      <p className="px-5 pb-5 pl-[3.25rem] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[3.75rem]">
                        {item.answer}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}